<ng-container *ngIf="agenteFinanceiro$ | async">

    <h5>Administração de Usuários do Agente Financeiro</h5>
    <br>
    
    <h4>Favor usar o portal do <strong>Fundo Garantidor para Investimentos – FGI</strong>
         para gerir os usuários do agente financeiro nos endereços a seguir:</h4>

    <h6>Produção: <a href="javascript:void(0)" (click)="fgiPRD()"> https://web.bndes.gov.br/FGI</a></h6>
    <h6>Homologação: <a href="javascript:void(0)" (click)="fgiHOM()"> https://web-h.bndes.gov.br/FGI</a></h6>
</ng-container>
<ng-container *ngIf="!(agenteFinanceiro$ | async)">

    <h5>Administração de Agentes Financeiros e Usuários</h5>
    <br>

    <h4>Favor usar o portal do <strong>Fundo Garantidor para Investimentos – FGI</strong> para gerir agentes financeiros e seus usuários nos endereços a seguir:</h4>

    <h6>Produção: <a href="javascript:void(0)" (click)="fgiPRD()"> https://web.bndes.gov.br/FGI</a></h6>
    <h6>Homologação: <a href="javascript:void(0)" (click)="fgiHOM()"> https://web-h.bndes.gov.br/FGI</a></h6>

    <h4>Favor usar o portal do <strong>Sistema Papéis e Grupos</strong> para gerir usuários internos (gestor):</h4>

    <h6>Produção e homologação: <a href="javascript:void(0)" (click)="n08()"> https://web.bndes.net/n08</a></h6>
</ng-container>